/* eslint-disable */

// @ts-nocheck

// noinspection JSUnusedGlobalSymbols

// This file was automatically generated by TanStack Router.
// You should NOT make any changes in this file as it will be overwritten.
// Additionally, you should also exclude this file from your linter and/or formatter to prevent it from being checked or modified.

import { Route as rootRouteImport } from './routes/__root'
import { Route as rootIndexRouteImport } from './routes/(root)/index'

const rootIndexRoute = rootIndexRouteImport.update({
  id: '/(root)/',
  path: '/',
  getParentRoute: () => rootRouteImport,
} as any)

export interface FileRoutesByFullPath {
  '/': typeof rootIndexRoute
}
export interface FileRoutesByTo {
  '/': typeof rootIndexRoute
}
export interface FileRoutesById {
  __root__: typeof rootRouteImport
  '/(root)/': typeof rootIndexRoute
}
export interface FileRouteTypes {
  fileRoutesByFullPath: FileRoutesByFullPath
  fullPaths: '/'
  fileRoutesByTo: FileRoutesByTo
  to: '/'
  id: '__root__' | '/(root)/'
  fileRoutesById: FileRoutesById
}
export interface RootRouteChildren {
  rootIndexRoute: typeof rootIndexRoute
}

declare module '@tanstack/react-router' {
  interface FileRoutesByPath {
    '/(root)/': {
      id: '/(root)/'
      path: '/'
      fullPath: '/'
      preLoaderRoute: typeof rootIndexRouteImport
      parentRoute: typeof rootRouteImport
    }
  }
}

const rootRouteChildren: RootRouteChildren = {
  rootIndexRoute: rootIndexRoute,
}
export const routeTree = rootRouteImport
  ._addFileChildren(rootRouteChildren)
  ._addFileTypes<FileRouteTypes>()
